{
  "level": "boiler",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:boiler",
    "objects": "AREAS.E3:boiler.e3",
    "mesh": "TREES.E3:boiler.e3"
  },
  "spawn_point": {
    "position": [
      582.9000404094828,
      1017.1865209119073,
      84.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      582.9000404094828,
      1117.1865209119073,
      84.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -309.5,
      730.0,
      60.0
    ],
    "bbox_max": [
      3717.71337890625,
      1569.29736328125,
      657.8189697265625
    ],
    "vertex_count": 145,
    "vertices": [
      [
        3717.71337890625,
        1569.29736328125,
        657.8189697265625
      ],
      [
        -309.5,
        1006.4411010742188,
        300.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        300.0
      ],
      [
        310.0,
        970.0,
        112.5
      ],
      [
        260.0,
        970.0,
        112.5
      ],
      [
        -294.2342224121094,
        980.0,
        300.0
      ],
      [
        -224.5146484375,
        980.0,
        300.0
      ],
      [
        -224.5146484375,
        980.0,
        350.0
      ],
      [
        -224.5146484375,
        980.0,
        300.0
      ],
      [
        300.0,
        980.0,
        120.0
      ],
      [
        300.0,
        970.0,
        112.5
      ],
      [
        1098.3634033203125,
        880.0,
        80.0
      ],
      [
        1018.0,
        910.5136108398438,
        80.0
      ],
      [
        1018.0,
        930.0,
        80.0
      ],
      [
        1010.0,
        960.0,
        130.0
      ],
      [
        1010.0,
        962.0,
        80.0
      ],
      [
        1010.0,
        913.5511474609375,
        80.0
      ],
      [
        1006.0,
        930.0,
        80.0
      ],
      [
        1006.0,
        957.9999389648438,
        80.0
      ],
      [
        1010.0,
        962.0,
        80.0
      ],
      [
        1006.0,
        1120.0,
        80.0
      ],
      [
        760.0,
        1096.0167236328125,
        80.0
      ],
      [
        743.1985473632812,
        1133.1986083984375,
        80.0
      ],
      [
        966.6787109375,
        930.0,
        80.0
      ],
      [
        960.0,
        932.535888671875,
        80.0
      ],
      [
        861.3309326171875,
        970.0,
        69.0367660522461
      ],
      [
        960.0,
        932.535888671875,
        80.0
      ],
      [
        749.1626586914062,
        1120.0,
        60.0
      ],
      [
        780.0,
        1051.7562255859375,
        60.0
      ],
      [
        780.0,
        1051.7562255859375,
        80.0
      ],
      [
        780.0,
        1051.7562255859375,
        60.0
      ],
      [
        780.0,
        1120.0,
        80.0
      ],
      [
        861.3309326171875,
        970.0,
        110.0
      ],
      [
        807.7503051757812,
        990.3443603515625,
        110.0
      ],
      [
        780.0,
        1051.7562255859375,
        110.0
      ],
      [
        780.0,
        1051.7562255859375,
        110.0
      ],
      [
        914.0048828125,
        950.0,
        140.0
      ],
      [
        914.0048828125,
        950.0,
        220.0
      ],
      [
        914.0048828125,
        950.0,
        140.0
      ],
      [
        963.1941528320312,
        931.3230590820312,
        140.0
      ],
      [
        796.0811157226562,
        1016.168212890625,
        170.0
      ],
      [
        822.5736083984375,
        1006.109130859375,
        170.0
      ],
      [
        822.5736083984375,
        1006.109130859375,
        170.0
      ],
      [
        865.0,
        990.0,
        170.0
      ],
      [
        865.0,
        990.0,
        170.0
      ],
      [
        893.1714477539062,
        979.3034057617188,
        170.0
      ],
      [
        835.0180053710938,
        930.0,
        86.11311340332031
      ],
      [
        835.0180053710938,
        930.0,
        66.11311340332031
      ],
      [
        835.0180053710938,
        930.0,
        86.11311340332031
      ],
      [
        835.0180053710938,
        930.0,
        140.0
      ],
      [
        816.9432373046875,
        970.0,
        64.10480499267578
      ],
      [
        835.0180053710938,
        930.0,
        66.11311340332031
      ],
      [
        825.9806518554688,
        950.0,
        115.00967407226562
      ],
      [
        825.9806518554688,
        950.0,
        117.00968170166016
      ],
      [
        825.9805908203125,
        950.0,
        140.0
      ],
      [
        825.9805908203125,
        950.0,
        220.0
      ],
      [
        825.9805908203125,
        950.0,
        140.0
      ],
      [
        835.0180053710938,
        930.0,
        140.0
      ],
      [
        835.0180053710938,
        930.0,
        110.49100494384766
      ],
      [
        825.9806518554688,
        950.0,
        115.00968170166016
      ],
      [
        816.9432983398438,
        970.0,
        110.0
      ],
      [
        760.0,
        1096.0167236328125,
        60.0
      ],
      [
        760.0,
        730.0,
        60.0
      ],
      [
        835.0180053710938,
        930.0,
        110.0
      ],
      [
        780.0,
        930.0,
        110.0
      ],
      [
        835.0180053710938,
        930.0,
        120.00000762939453
      ],
      [
        780.0,
        950.0,
        120.0
      ],
      [
        780.0,
        950.0,
        118.0
      ],
      [
        725.7142333984375,
        930.0,
        60.0
      ],
      [
        727.0,
        927.0,
        66.00000762939453
      ],
      [
        360.0,
        921.0000610351562,
        78.0
      ],
      [
        360.0,
        920.0,
        80.0
      ],
      [
        320.0,
        928.0,
        64.0
      ],
      [
        310.0,
        928.0,
        64.0
      ],
      [
        370.0,
        1181.0,
        77.5
      ],
      [
        370.0,
        985.0,
        77.5
      ],
      [
        320.0,
        955.0,
        77.5
      ],
      [
        310.0,
        955.0,
        77.5
      ],
      [
        429.5,
        985.0,
        77.5
      ],
      [
        429.5,
        995.0,
        77.5
      ],
      [
        429.5,
        995.0,
        77.5
      ],
      [
        429.5,
        1181.0,
        77.5
      ],
      [
        429.5,
        1181.0,
        77.5
      ],
      [
        370.0,
        1181.0,
        77.5
      ],
      [
        370.0,
        985.0,
        77.5
      ],
      [
        429.5,
        985.0,
        77.5
      ],
      [
        370.0,
        1181.0,
        79.0
      ],
      [
        370.0,
        985.0,
        79.0
      ],
      [
        360.0,
        940.0,
        79.0
      ],
      [
        360.0,
        920.5,
        79.0
      ],
      [
        320.0,
        958.0,
        79.0
      ],
      [
        310.0,
        958.0,
        79.0
      ],
      [
        429.5,
        985.0,
        79.0
      ],
      [
        429.5,
        995.0,
        79.0
      ],
      [
        429.5,
        995.0,
        79.0
      ],
      [
        429.5,
        1181.0,
        79.0
      ],
      [
        429.5,
        1181.0,
        79.0
      ],
      [
        370.0,
        1181.0,
        79.0
      ],
      [
        370.0,
        985.0,
        79.0
      ],
      [
        429.5,
        985.0,
        79.0
      ],
      [
        370.0,
        1181.0,
        80.0
      ],
      [
        370.0,
        985.0,
        80.0
      ],
      [
        429.5,
        985.0,
        80.0
      ],
      [
        429.5,
        995.0,
        80.0
      ],
      [
        429.5,
        995.0,
        80.0
      ],
      [
        429.5,
        1181.0,
        80.0
      ],
      [
        429.5,
        1181.0,
        80.0
      ],
      [
        370.0,
        1181.0,
        80.0
      ],
      [
        370.0,
        985.0,
        80.0
      ],
      [
        429.5,
        985.0,
        80.0
      ],
      [
        429.5,
        1000.0,
        145.0
      ],
      [
        440.0,
        1000.0,
        145.0
      ],
      [
        370.0,
        1000.0,
        145.0
      ],
      [
        429.5,
        1000.0,
        145.0
      ],
      [
        440.0,
        1000.0,
        120.0
      ],
      [
        440.0,
        1000.0,
        145.0
      ],
      [
        370.0,
        1000.0,
        120.0
      ],
      [
        370.0,
        1000.0,
        145.0
      ],
      [
        429.5,
        1000.0,
        145.0
      ],
      [
        429.5,
        1000.0,
        120.0
      ],
      [
        429.5,
        1000.0,
        120.0
      ],
      [
        429.5,
        1000.0,
        145.0
      ],
      [
        429.5,
        1181.0,
        135.0
      ],
      [
        429.5,
        1181.0,
        136.0
      ],
      [
        429.5,
        1181.0,
        136.0
      ],
      [
        429.5,
        1181.0,
        136.0
      ],
      [
        429.5,
        1181.0,
        135.0
      ],
      [
        429.5,
        1162.0,
        135.0
      ],
      [
        429.5,
        1181.0,
        135.0
      ],
      [
        429.5,
        1181.0,
        136.0
      ],
      [
        429.5,
        1162.0,
        136.0
      ],
      [
        429.5,
        1162.0,
        135.0
      ],
      [
        429.5,
        1162.0,
        136.0
      ],
      [
        429.5,
        1166.5,
        135.0
      ],
      [
        429.5,
        1166.5,
        135.0
      ],
      [
        429.5,
        1162.0,
        135.0
      ],
      [
        429.5,
        1176.5,
        135.0
      ],
      [
        440.0,
        985.0,
        160.0
      ],
      [
        440.0,
        985.0,
        160.0
      ],
      [
        440.0,
        997.0,
        145.0
      ],
      [
        440.0,
        985.0,
        145.0
      ],
      [
        440.0,
        997.0,
        145.0
      ],
      [
        440.0,
        985.0,
        145.0
      ],
      [
        440.0,
        1000.0,
        145.0
      ],
      [
        440.0,
        997.0,
        145.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -1125.0457763671875,
        -1553.390625,
        -300.0
      ],
      "bbox_max": [
        7986.5068359375,
        3895.50634765625,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1491488516330719,
        -0.38985106348991394,
        0.9087193608283997
      ],
      "plane_d": 568.5121459960938,
      "bbox_min": [
        -309.5032958984375,
        250.0,
        60.0
      ],
      "bbox_max": [
        7986.5068359375,
        3895.50634765625,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        3240.0,
        1569.29736328125,
        460.0
      ],
      "bbox_max": [
        4137.6171875,
        2280.14306640625,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -309.5032958984375,
        250.0,
        60.0
      ],
      "bbox_max": [
        1769.9998779296875,
        1689.9998779296875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 309.5,
      "bbox_min": [
        -309.5032958984375,
        911.17822265625,
        105.0
      ],
      "bbox_max": [
        310.0,
        1115.0986328125,
        540.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -235.18533325195312,
      "bbox_min": [
        -309.5,
        911.17822265625,
        105.0
      ],
      "bbox_max": [
        310.0,
        1115.0986328125,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        120.00611877441406
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        -309.5,
        960.0,
        105.0
      ],
      "bbox_max": [
        310.0,
        1115.0986328125,
        420.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        260.0,
        960.0,
        105.0
      ],
      "bbox_max": [
        310.0,
        970.0,
        112.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        -309.5,
        970.0,
        109.0
      ],
      "bbox_max": [
        310.0,
        1115.0986328125,
        350.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.5,
        980.0,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -224.5146484375,
        980.0,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1045.8167724609375,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -294.2342224121094,
        970.0,
        109.0
      ],
      "bbox_max": [
        310.0,
        980.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -229.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -224.5146484375,
        980.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        260.0,
        970.0,
        109.0
      ],
      "bbox_max": [
        310.0,
        980.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        260.0,
        970.0,
        112.5
      ],
      "bbox_max": [
        300.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        300.0,
        970.0,
        112.5
      ],
      "bbox_max": [
        310.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        310.0,
        570.0,
        60.0
      ],
      "bbox_max": [
        1769.9998779296875,
        1689.9998779296875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1588.2841796875,
        1469.9998779296875,
        500.0
      ],
      "bbox_max": [
        1769.9998779296875,
        1469.9998779296875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112825989723206,
        -0.4117816090583801,
        -0.0
      ],
      "plane_d": 1143.894287109375,
      "bbox_min": [
        310.0,
        570.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        1252.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35496851801872253,
        -0.9348782300949097,
        -0.0
      ],
      "plane_d": 1212.5772705078125,
      "bbox_min": [
        743.1985473632812,
        760.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        1252.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        743.1985473632812,
        760.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        1252.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1018.0,
        760.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        980.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        1018.0,
        760.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        930.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1018.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1380.0,
        930.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27716064453125,
        0.9608235955238342,
        0.0
      ],
      "plane_d": -491.8677978515625,
      "bbox_min": [
        1276.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1380.0,
        910.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1380.0,
      "bbox_min": [
        1380.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1380.0,
        910.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        743.1985473632812,
        910.5136108398438,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1252.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1006.0,
        910.5136108398438,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        1006.0,
        910.5136108398438,
        80.0
      ],
      "bbox_max": [
        1018.0,
        962.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1010.0,
        910.5136108398438,
        80.0
      ],
      "bbox_max": [
        1018.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1006.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        962.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        1006.0,
        957.9999389648438,
        80.0
      ],
      "bbox_max": [
        1020.0,
        1120.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1010.0,
        960.0,
        130.0
      ],
      "bbox_max": [
        1020.0,
        1090.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1006.0,
        957.9999389648438,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        743.1985473632812,
        930.0,
        60.0
      ],
      "bbox_max": [
        1008.2842407226562,
        1252.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        749.1626586914062,
        932.535888671875,
        60.0
      ],
      "bbox_max": [
        960.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        749.1626586914062,
        1051.7562255859375,
        60.0
      ],
      "bbox_max": [
        780.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1051.7562255859375,
        60.0
      ],
      "bbox_max": [
        780.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        780.0,
        931.3230590820312,
        80.0
      ],
      "bbox_max": [
        1008.2842407226562,
        1252.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 805.3590087890625,
      "bbox_min": [
        805.3590087890625,
        1212.0,
        140.0
      ],
      "bbox_max": [
        805.3590087890625,
        1252.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        783.0528564453125,
        931.3230590820312,
        110.0
      ],
      "bbox_max": [
        1008.2842407226562,
        1045.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 139.99998474121094,
      "bbox_min": [
        914.0048828125,
        931.3230590820312,
        140.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        -0.9348779320716858,
        0.0
      ],
      "plane_d": 1232.57763671875,
      "bbox_min": [
        783.0528564453125,
        950.0,
        110.0
      ],
      "bbox_max": [
        980.0,
        1045.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        783.0528564453125,
        950.0,
        110.0
      ],
      "bbox_max": [
        980.0,
        1045.0,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 330.9380798339844,
      "bbox_min": [
        960.0,
        950.0,
        110.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        980.0,
        950.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        970.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 169.99998474121094,
      "bbox_min": [
        796.0811157226562,
        968.6068725585938,
        170.0
      ],
      "bbox_max": [
        893.1714477539062,
        1016.168212890625,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        807.7503051757812,
        880.0,
        64.10480499267578
      ],
      "bbox_max": [
        1098.3634033203125,
        990.3443603515625,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1010.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1098.3634033203125,
        913.5511474609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        807.7503051757812,
        930.0,
        64.10480499267578
      ],
      "bbox_max": [
        966.6787109375,
        990.3443603515625,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        960.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        966.6787109375,
        932.535888671875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        807.7503051757812,
        930.0,
        108.0
      ],
      "bbox_max": [
        963.1941528320312,
        990.3443603515625,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 139.99998474121094,
      "bbox_min": [
        825.9805908203125,
        930.0,
        108.0
      ],
      "bbox_max": [
        963.1941528320312,
        950.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 472.2575988769531,
      "bbox_min": [
        825.9806518554688,
        930.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        950.0,
        115.00968170166016
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        807.7503051757812,
        950.0,
        108.0
      ],
      "bbox_max": [
        861.3309326171875,
        990.3443603515625,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        840.0,
        950.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        310.0,
        570.0,
        60.0
      ],
      "bbox_max": [
        835.0180053710938,
        1191.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        725.7142333984375,
        700.0,
        60.0
      ],
      "bbox_max": [
        835.0180053710938,
        1133.1986083984375,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        760.0,
        701.7157592773438,
        60.0
      ],
      "bbox_max": [
        835.0180053710938,
        1096.0167236328125,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 139.99998474121094,
      "bbox_min": [
        760.0,
        701.7157592773438,
        60.0
      ],
      "bbox_max": [
        835.0180053710938,
        1051.7562255859375,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        760.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        825.9805908203125,
        950.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        760.0,
        730.0,
        60.0
      ],
      "bbox_max": [
        835.0180053710938,
        1051.7562255859375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        760.0,
        750.0,
        60.0
      ],
      "bbox_max": [
        835.0180053710938,
        1051.7562255859375,
        120.00000762939453
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        835.0180053710938,
        1051.7562255859375,
        120.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        835.0180053710938,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        835.0180053710938,
        930.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        835.0180053710938,
        950.0,
        120.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        780.0,
        930.0,
        110.49100494384766
      ],
      "bbox_max": [
        835.0180053710938,
        950.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 472.2575988769531,
      "bbox_min": [
        820.0,
        930.0,
        110.49100494384766
      ],
      "bbox_max": [
        835.0180053710938,
        950.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        760.0,
        950.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        120.0
      ],
      "bbox_max": [
        835.0180053710938,
        930.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        930.0,
        120.0
      ],
      "bbox_max": [
        835.0180053710938,
        930.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        725.7142333984375,
        700.0,
        60.0
      ],
      "bbox_max": [
        760.0,
        1133.1986083984375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        725.7142333984375,
        726.0,
        60.0
      ],
      "bbox_max": [
        760.0,
        1133.1986083984375,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        725.7142333984375,
        750.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1130.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        725.7142333984375,
        927.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        930.0,
        66.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        310.0,
        570.0,
        60.0
      ],
      "bbox_max": [
        727.0,
        1191.0,
        460.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        310.0,
        570.0,
        60.0
      ],
      "bbox_max": [
        727.0,
        1181.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        310.0,
        570.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -360.0,
      "bbox_min": [
        310.0,
        730.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        928.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 357.7709045410156,
      "bbox_min": [
        310.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        320.0,
        928.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -77.5,
      "bbox_min": [
        310.0,
        920.0,
        64.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        310.0,
        928.0,
        64.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        77.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 357.7709045410156,
      "bbox_min": [
        310.0,
        928.0,
        64.0
      ],
      "bbox_max": [
        320.0,
        955.0,
        77.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 429.5,
      "bbox_min": [
        370.0,
        985.0,
        76.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        77.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1181.0,
      "bbox_min": [
        370.0,
        985.0,
        76.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        77.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        370.0,
        985.0,
        76.0
      ],
      "bbox_max": [
        429.5,
        985.0,
        77.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -79.0,
      "bbox_min": [
        310.0,
        920.0,
        77.5
      ],
      "bbox_max": [
        429.5,
        1181.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        310.0,
        920.5,
        77.5
      ],
      "bbox_max": [
        429.5,
        1181.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -360.0,
      "bbox_min": [
        310.0,
        920.5,
        77.5
      ],
      "bbox_max": [
        360.0,
        958.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 357.7709045410156,
      "bbox_min": [
        310.0,
        955.0,
        77.5
      ],
      "bbox_max": [
        320.0,
        958.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 429.5,
      "bbox_min": [
        370.0,
        985.0,
        77.5
      ],
      "bbox_max": [
        429.5,
        1181.0,
        79.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1181.0,
      "bbox_min": [
        370.0,
        985.0,
        77.5
      ],
      "bbox_max": [
        429.5,
        1181.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        370.0,
        985.0,
        77.5
      ],
      "bbox_max": [
        429.5,
        985.0,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        310.0,
        920.0,
        79.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -360.0,
      "bbox_min": [
        310.0,
        920.0,
        79.0
      ],
      "bbox_max": [
        360.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 357.7709045410156,
      "bbox_min": [
        310.0,
        958.0,
        79.0
      ],
      "bbox_max": [
        320.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 429.5,
      "bbox_min": [
        370.0,
        985.0,
        79.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1181.0,
      "bbox_min": [
        370.0,
        985.0,
        79.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        370.0,
        985.0,
        79.0
      ],
      "bbox_max": [
        429.5,
        985.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        310.0,
        869.8349609375,
        80.0
      ],
      "bbox_max": [
        720.0,
        1191.0,
        460.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1003.95166015625,
      "bbox_min": [
        499.80194091796875,
        869.8349609375,
        80.0
      ],
      "bbox_max": [
        600.1320190429688,
        920.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -226.18081665039062,
      "bbox_min": [
        549.9669799804688,
        869.8349609375,
        80.0
      ],
      "bbox_max": [
        600.1320190429688,
        920.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        310.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1191.0,
        340.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        370.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1191.0,
        160.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        370.0,
        985.0,
        80.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 429.5,
      "bbox_min": [
        370.0,
        985.0,
        80.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1181.0,
      "bbox_min": [
        370.0,
        985.0,
        80.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        370.0,
        985.0,
        80.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 114.5,
      "bbox_min": [
        370.0,
        985.0,
        114.5
      ],
      "bbox_max": [
        429.5,
        1181.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1162.0,
      "bbox_min": [
        370.0,
        1007.0,
        114.5
      ],
      "bbox_max": [
        429.5,
        1162.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1007.0,
      "bbox_min": [
        370.0,
        1007.0,
        114.5
      ],
      "bbox_max": [
        429.5,
        1007.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        370.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        720.0,
        1191.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        370.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1191.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 145.0,
      "bbox_min": [
        370.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        1191.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 440.0,
      "bbox_min": [
        370.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        1191.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        370.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        1191.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 429.5,
      "bbox_min": [
        370.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        1191.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1181.0,
      "bbox_min": [
        429.5,
        1162.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        1181.0,
        145.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1162.0,
      "bbox_min": [
        429.5,
        1162.0,
        135.0
      ],
      "bbox_max": [
        431.0,
        1162.0,
        136.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -431.0,
      "bbox_min": [
        429.5,
        1162.0,
        120.0
      ],
      "bbox_max": [
        431.0,
        1181.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1166.5,
      "bbox_min": [
        429.5,
        1162.0,
        120.0
      ],
      "bbox_max": [
        431.0,
        1176.5,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1161.9998779296875,
      "bbox_min": [
        429.5,
        1162.0,
        120.0
      ],
      "bbox_max": [
        431.0,
        1162.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1176.4998779296875,
      "bbox_min": [
        429.5,
        1176.5,
        120.0
      ],
      "bbox_max": [
        431.0,
        1176.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": 657.8511962890625,
      "bbox_min": [
        370.0,
        1162.0,
        120.0
      ],
      "bbox_max": [
        429.5,
        1191.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 420.8279724121094,
      "bbox_min": [
        370.0,
        1162.0,
        120.0
      ],
      "bbox_max": [
        429.5,
        1191.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1191.0,
      "bbox_min": [
        370.0,
        1162.0,
        120.0
      ],
      "bbox_max": [
        429.5,
        1191.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        -0.4472135901451111,
        0.0
      ],
      "plane_d": 912.315673828125,
      "bbox_min": [
        370.0,
        1162.0,
        120.0
      ],
      "bbox_max": [
        429.5,
        1191.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.4472135901451111,
        0.0
      ],
      "plane_d": 197.22119140625,
      "bbox_min": [
        370.0,
        1162.0,
        120.0
      ],
      "bbox_max": [
        429.5,
        1191.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1181.0,
      "bbox_min": [
        370.0,
        1162.0,
        120.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        145.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.9832895994186401,
        0.0,
        0.182048499584198
      ],
      "plane_d": 395.92584228515625,
      "bbox_min": [
        426.260009765625,
        1162.0,
        120.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        145.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        426.260009765625,
        1162.0,
        120.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        136.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -136.0,
      "bbox_min": [
        427.6485900878906,
        1162.0,
        135.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        136.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1162.0,
      "bbox_min": [
        427.6485900878906,
        1162.0,
        135.0
      ],
      "bbox_max": [
        429.5,
        1162.0,
        136.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1166.5,
      "bbox_min": [
        426.260009765625,
        1162.0,
        120.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1161.9998779296875,
      "bbox_min": [
        426.260009765625,
        1162.0,
        120.0
      ],
      "bbox_max": [
        429.5,
        1166.5,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9180020689964294,
        -0.0,
        -0.3965756893157959
      ],
      "plane_d": 441.8709716796875,
      "bbox_min": [
        426.260009765625,
        1162.0,
        120.0
      ],
      "bbox_max": [
        429.5,
        1166.5,
        127.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1176.4998779296875,
      "bbox_min": [
        426.260009765625,
        1176.5,
        120.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9180020689964294,
        0.0,
        -0.3965756893157959
      ],
      "plane_d": 441.8709716796875,
      "bbox_min": [
        426.260009765625,
        1176.5,
        120.0
      ],
      "bbox_max": [
        429.5,
        1181.0,
        127.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -985.0,
      "bbox_min": [
        370.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        1000.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        985.0,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 440.0,
      "bbox_min": [
        440.0,
        985.0,
        145.0
      ],
      "bbox_max": [
        440.0,
        1000.0,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 440.0,
      "bbox_min": [
        429.5,
        985.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        1000.0,
        145.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -996.0,
      "bbox_min": [
        429.5,
        995.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        996.0,
        145.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 995.0,
      "bbox_min": [
        429.5,
        995.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        996.0,
        145.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -431.0,
      "bbox_min": [
        431.0,
        995.0,
        120.0
      ],
      "bbox_max": [
        438.0,
        996.0,
        132.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 438.0,
      "bbox_min": [
        431.0,
        995.0,
        120.0
      ],
      "bbox_max": [
        438.0,
        996.0,
        132.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.5,
      "bbox_min": [
        431.0,
        995.0,
        132.5
      ],
      "bbox_max": [
        438.0,
        996.0,
        132.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        310.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: exitdr",
      "entity_class": "CSlidingDoor",
      "piece_name": "exitdr",
      "offset": 7952,
      "centroid": [
        430.0,
        1171.5,
        127.49948501586914
      ],
      "bbox_min": [
        429.5,
        1166.5,
        120.0
      ],
      "bbox_max": [
        430.5,
        1176.5,
        135.0
      ],
      "dimensions_source": {
        "span_x": 1.0,
        "span_y": 10.0,
        "height_z": 15.0,
        "door_width": 10.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          -0.0
        ]
      },
      "vertices": [
        [
          429.5,
          1166.5,
          120.0
        ],
        [
          429.5,
          1166.5,
          135.0
        ],
        [
          430.5,
          1176.5,
          120.0
        ],
        [
          430.5,
          1166.5,
          120.0
        ],
        [
          430.5,
          1166.5,
          135.0
        ],
        [
          430.5,
          1176.5,
          134.99794006347656
        ],
        [
          429.5,
          1176.5,
          120.0
        ],
        [
          429.5,
          1176.5,
          134.99794006347656
        ]
      ],
      "plane_distance": 429.5,
      "authentic_texture": "slidedoor1"
    }
  ],
  "tutorial_messages": []
}